/**
 * @generated SignedSource<<665a589088af4d313ca174bc186ac5cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SchoolDetailQuery$variables = {
  id: string;
};
export type SchoolDetailQuery$data = {
  readonly school: {
    readonly id: string;
    readonly name: string;
  };
};
export type SchoolDetailQuery = {
  response: SchoolDetailQuery$data;
  variables: SchoolDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "School",
    "kind": "LinkedField",
    "name": "school",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SchoolDetailQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SchoolDetailQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4a812ef3753b629a50b9f99dddf0622c",
    "id": null,
    "metadata": {},
    "name": "SchoolDetailQuery",
    "operationKind": "query",
    "text": "query SchoolDetailQuery(\n  $id: ID!\n) {\n  school(id: $id) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa5da8363f54859d80d41551dda18786";

export default node;
